/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as RSTooltip } from 'reactstrap';
import styles from './styles.css';

class Tooltip extends React.Component {
  static propTypes = {
    uniqueTargetSelector: PropTypes.string.isRequired,
    tootipContent: PropTypes.node.isRequired,
    placement: PropTypes.oneOf([
      'auto',
      'auto-start',
      'auto-end',
      'top',
      'top-start',
      'top-end',
      'right',
      'right-start',
      'right-end',
      'bottom',
      'bottom-start',
      'bottom-end',
      'left',
      'left-start',
      'left-end',
    ]),
    size: PropTypes.oneOf(['sm', 'lg']),
  }

  static defaultProps = {
    placement: 'top',
    size: 'lg',
  }

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  handleToggleToolTip = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  }

  render() {
    const { uniqueTargetSelector, tootipContent, placement, size } = this.props;
    const { isOpen } = this.state;

    return (
      <RSTooltip
        target={uniqueTargetSelector}
        isOpen={isOpen}
        placement={placement}
        toggle={this.handleToggleToolTip}
        boundariesElement="window"
        innerClassName={`${styles.customTooltip} ${styles[size]}`}
      >
        {tootipContent}
      </RSTooltip>
    );
  }
}

export default Tooltip;
